import {
  SAVE_FEATURE_CHECK_SUCCESS,
  SAVE_FEATURE_CHECK_ERROR,
} from 'actionTypes'

const DEFAULT_STATE = {
  list: {
    records: [],
    error: null,
    isFetching: false,
  },
  get: {
    record: {},
    error: null,
    isFetching: false,
  },
  edit: {
    record: {},
    error: null,
    isUpdating: false,
    updated: false,
    removed: false,
  },
}

const record = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case SAVE_FEATURE_CHECK_SUCCESS:
      return {
        ...state,
        data: action.payload,
        list: {
          ...state.edit,
          updated: true,
        },
      }
    case SAVE_FEATURE_CHECK_ERROR:
      return {
        ...state,
        edit: {
          ...state.edit,
          error: action.payload,
          updated: false,
          removed: false,
        },
      }
    default:
      return state
  }
}

export default record
